var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBhand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 87,
    viewBox: "0 0 75 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3678 73.5754C45.3678 73.5754 45.5917 63.389 45.3678 60.4786C45.1439 57.5682 45.7036 57.0086 45.3678 54.7698C45.032 52.531 42.9052 50.852 43.0171 37.9791L43.0126 36.5239C43.0126 36.5239 42.7869 33.2777 44.2448 29.4718C45.7027 25.6659 45.5908 24.7704 46.1505 23.0914C46.7101 21.4123 48.1653 12.4573 50.0683 12.1214C51.9712 11.7856 52.5309 13.4647 51.8593 16.1512C51.1877 18.8377 50.7399 21.0765 50.7399 23.0914C50.7399 25.1062 50.8518 27.5689 48.837 28.4644",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.064 15.1136C52.064 15.1136 52.9792 10.928 53.5765 8.61399C54.1738 6.30091 54.6215 4.58423 56.5612 5.10631C58.5017 5.62838 57.6062 7.5564 57.1585 10.0629C56.7107 12.5694 56.4125 16.1514 56.4125 16.9717C56.4125 17.7929 56.3382 23.6137 55.2932 25.0313",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7593 6.97245C57.7593 6.97245 58.2034 4.36027 58.2787 3.31611C58.3539 2.27195 58.4282 0.9278 60.5174 1.00302C62.6066 1.07735 62.6819 3.24178 62.458 7.4211C62.2341 11.6004 62.3837 12.5702 62.2341 15.3311C62.0846 18.0919 60.9652 22.3456 60.8909 23.5402C60.8909 23.5402 60.8165 24.6595 60.8165 25.4807",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.458 7.4203C62.458 7.4203 62.6819 5.18154 64.3233 5.47974C65.9648 5.77794 66.786 6.73792 66.786 12.0787C66.786 17.4195 67.2337 20.0317 66.786 24.3596C66.3382 28.6876 66.9597 30.1061 66.9848 32.3448",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2037 40.5536C63.2037 40.5536 64.3974 40.3297 65.2186 38.4644C66.0398 36.599 66.6612 35.1062 66.9845 32.3454C67.3078 29.5846 69.92 25.6291 72.0835 25.4796C74.248 25.33 74.248 26.599 73.6507 27.8679C73.0534 29.1368 72.8295 30.4048 72.4569 32.4197C72.0835 34.4346 71.3376 35.9274 71.188 37.1954C71.0385 38.4635 71.1137 41.7419 71.1137 42.8273C71.1137 43.9126 70.5164 44.5833 69.0988 46.1505C67.6812 47.7176 65.2678 51.5978 64.7207 52.2695C64.1735 52.9411 63.3524 53.3888 62.4569 54.0605C61.5614 54.7321 60.8154 56.3736 61.0393 60.8511C61.2632 65.3286 60.81 69.3584 60.999 72.3431C61.1879 75.3278 61.8596 80.1044 62.0834 80.9999",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9943 38.9141C64.9943 38.9141 64.2295 37.364 63.0537 37.5315",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7656 74V45.5625H24.7266C28.1771 45.5625 30.7943 46.2266 32.5781 47.5547C34.362 48.8698 35.2539 50.8034 35.2539 53.3555C35.2539 54.7487 34.8958 55.9792 34.1797 57.0469C33.4635 58.1016 32.4674 58.8763 31.1914 59.3711C32.6497 59.7357 33.7956 60.4714 34.6289 61.5781C35.4753 62.6849 35.8984 64.0391 35.8984 65.6406C35.8984 68.375 35.026 70.4453 33.2812 71.8516C31.5365 73.2578 29.0495 73.974 25.8203 74H14.7656ZM20.625 61.6172V69.293H25.6445C27.0247 69.293 28.099 68.9674 28.8672 68.3164C29.6484 67.6523 30.0391 66.7409 30.0391 65.582C30.0391 62.9779 28.6914 61.6562 25.9961 61.6172H20.625ZM20.625 57.4766H24.9609C27.9167 57.4245 29.3945 56.2461 29.3945 53.9414C29.3945 52.6523 29.0169 51.7279 28.2617 51.168C27.5195 50.5951 26.3411 50.3086 24.7266 50.3086H20.625V57.4766Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 62.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBhand);
export default __webpack_public_path__ + "static/media/Bhand.f81f80284254e7ed2de36166115fd805.svg";
export { ForwardRef as ReactComponent };